<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const props = defineProps({
  visible: { type: Boolean, default: false },
});
const emit = defineEmits(['open', 'details']);
const { t } = useI18n();
const menuOpen = ref(false);
const menuSections = computed(() => [
  {
    title: t('REAL_ESTATE_COMMISSION_SUPPORT.ACTIONS.MENU_TITLE'),
    items: [
      {
        action: 'open',
        icon: 'i-lucide-pencil',
        label: t('REAL_ESTATE_COMMISSION_SUPPORT.ACTIONS.SHEETS'),
        value: 'open',
      },
      {
        action: 'details',
        icon: 'i-lucide-info',
        label: t('REAL_ESTATE_COMMISSION_SUPPORT.ACTIONS.DETAILS'),
        value: 'details',
      },
    ],
  },
]);

const handleAction = ({ action }) => {
  menuOpen.value = false;
  if (action === 'open') emit('open');
  if (action === 'details') emit('details');
};
</script>

<template>
  <div
    v-on-clickaway="() => (menuOpen = false)"
    data-testid="commission-support-row-actions"
    class="relative inline-flex transition-opacity duration-150"
    :class="
      props.visible || menuOpen
        ? 'opacity-100'
        : 'pointer-events-none opacity-0'
    "
  >
    <button
      type="button"
      :aria-expanded="menuOpen ? 'true' : 'false'"
      aria-haspopup="menu"
      class="rounded-[10px] bg-[#0BB3A5] px-4 py-2 font-roboto text-sm font-bold text-white shadow-sm transition hover:bg-[#01988C]"
      @click="menuOpen = !menuOpen"
    >
      {{ t('REAL_ESTATE_COMMISSION_SUPPORT.ACTIONS.OPTIONS') }}
    </button>
    <DropdownMenu
      v-if="menuOpen"
      :menu-sections="menuSections"
      class="right-0 top-full mt-1 w-48"
      @action="handleAction"
    />
  </div>
</template>
